var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexSlider/IndexSlider.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexSlider/IndexSlider.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "isPromo", "isActive", "index"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isPromo", Object.prototype.hasOwnProperty.call(kwargs, "isPromo") ? kwargs["isPromo"] : true);frame.set("isActive", Object.prototype.hasOwnProperty.call(kwargs, "isActive") ? kwargs["isActive"] : false);frame.set("index", Object.prototype.hasOwnProperty.call(kwargs, "index") ? kwargs["index"] : 0);var t_5 = "";t_5 += "\n    <div class=\"IndexSlider-slide IndexSlider-slide--";
if(runtime.contextOrFrameLookup(context, frame, "isPromo")) {
t_5 += "promo";
;
}
else {
t_5 += "craft";
;
}
t_5 += " ";
if(runtime.contextOrFrameLookup(context, frame, "isActive")) {
t_5 += "IndexSlider-slide--active";
;
}
t_5 += "\">\n        <a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"link"), env.opts.autoescape);
t_5 += "\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "isPromo")) {
t_5 += "\n                <div class=\"IndexSlider-slidePromoImage IndexSlider-slidePromoImage--";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask"), env.opts.autoescape);
t_5 += "\">\n                    <div class=\"IndexSlider-slidePromoImageAspect\">\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask") == "square") {
t_5 += "\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1106 1106\" width=\"100%\" height=\"100%\">\n                                <defs>\n                                    <mask id=\"IndexSlides-mask-";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask"), env.opts.autoescape);
t_5 += "-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_5 += "\">\n                                        <path fill-rule=\"evenodd\" fill=\"#fff\" d=\"M0.885,234.236 L871.764,0.885 L1105.115,871.765 L234.236,1105.116 L0.885,234.236 Z\"/>\n                                    </mask>\n                                </defs>\n                                <g mask=\"url(#IndexSlides-mask-";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask"), env.opts.autoescape);
t_5 += "-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_5 += ")\">\n                                    <image xlink:href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"img")),"w1366_url"), env.opts.autoescape);
t_5 += "\" x=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"position")),"x"), env.opts.autoescape);
t_5 += "\" y=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"position")),"y"), env.opts.autoescape);
t_5 += "\" width=\"100%\" height=\"100%\" preserveAspectRatio=\"xMidYMid slice\"/>\n                                </g>\n                            </svg>\n                        ";
;
}
t_5 += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask") == "triangle") {
t_5 += "\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1117 1268\" width=\"100%\" height=\"100%\">\n                                <defs>\n                                    <mask id=\"IndexSlides-mask-";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask"), env.opts.autoescape);
t_5 += "-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_5 += "\">\n                                        <path fill-rule=\"evenodd\" fill=\"#fff\" d=\"M259.229,0.652 L259.229,0.652 L1116.957,968.056 L0.228,1267.215 L259.229,0.652 Z\"/>\n                                    </mask>\n                                </defs>\n                                <g mask=\"url(#IndexSlides-mask-";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask"), env.opts.autoescape);
t_5 += "-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_5 += ")\">\n                                    <image xlink:href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"img")),"w1366_url"), env.opts.autoescape);
t_5 += "\" x=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"position")),"x"), env.opts.autoescape);
t_5 += "\" y=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"position")),"y"), env.opts.autoescape);
t_5 += "\" width=\"100%\" height=\"100%\" preserveAspectRatio=\"xMidYMid slice\"/>\n                                </g>\n                            </svg>\n                        ";
;
}
t_5 += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask") == "semicircle") {
t_5 += "\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1136 1136\" width=\"100%\" height=\"100%\">\n                                <defs>\n                                    <mask id=\"IndexSlides-mask-";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask"), env.opts.autoescape);
t_5 += "-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_5 += "\">\n                                        <path fill-rule=\"evenodd\" fill=\"#fff\" d=\"M941.025,0.094 C1200.857,259.927 1200.857,681.198 941.025,941.031 C681.192,1200.862 259.920,1200.862 0.088,941.031 \"/>\n                                    </mask>\n                                </defs>\n                                <g mask=\"url(#IndexSlides-mask-";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"mask"), env.opts.autoescape);
t_5 += "-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_5 += ")\">\n                                    <image xlink:href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"img")),"w1366_url"), env.opts.autoescape);
t_5 += "\" x=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"position")),"x"), env.opts.autoescape);
t_5 += "\" y=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"position")),"y"), env.opts.autoescape);
t_5 += "\" width=\"100%\" height=\"100%\" preserveAspectRatio=\"xMidYMid slice\"/>\n                                </g>\n                            </svg>\n                        ";
;
}
t_5 += "\n                    </div>\n                </div>\n            ";
;
}
else {
t_5 += "\n                <div class=\"IndexSlider-slideCraftImage\">\n                    <div class=\"IndexSlider-slideCraftImageAspect\">\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"member")) {
t_5 += "\n                            <div class=\"IndexSlider-slideCraftImageAuthor\">\n                                <div class=\"IndexSlider-slideCraftImageAuthorName\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"member")),"name"), env.opts.autoescape);
t_5 += "</div>\n                                <div class=\"IndexSlider-slideCraftImageAuthorClassification\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"member")),"classification"), env.opts.autoescape);
t_5 += "</div>\n                            </div>\n                        ";
;
}
t_5 += "\n                        <div class=\"IndexSlider-slideCraftImageWrapper\">\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1106 1106\" width=\"100%\" height=\"100%\">\n                                <defs>\n                                    <mask id=\"IndexSlides-mask-craft-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_5 += "\">\n                                        <path fill-rule=\"evenodd\" fill=\"#fff\" d=\"M0.885,234.236 L871.764,0.885 L1105.115,871.765 L234.236,1105.116 L0.885,234.236 Z\"/>\n                                    </mask>\n                                </defs>\n                                <g mask=\"url(#IndexSlides-mask-craft-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
t_5 += ")\">\n                                    <image xlink:href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"img")),"w1366_url"), env.opts.autoescape);
t_5 += "\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" preserveAspectRatio=\"xMidYMid slice\"/>\n                                </g>\n                            </svg>\n                        </div>\n                    </div>\n                </div>\n            ";
;
}
t_5 += "\n\n            <div class=\"IndexSlider-slideInfo ";
if((!runtime.contextOrFrameLookup(context, frame, "isPromo")) && (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"craft") == "stg")) {
t_5 += " IndexSlider-slideInfo--highlight";
;
}
t_5 += "\">\n                <h3><span>";
if(runtime.contextOrFrameLookup(context, frame, "isPromo")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
;
}
else {
t_5 += "ADG<br> Represents ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"classification"), env.opts.autoescape);
;
}
t_5 += "</span></h3>\n                <div class=\"IndexSlider-slideInfoArrow\">\n                    ";
t_5 += runtime.suppressValue((lineno = 75, colno = 42, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
t_5 += "\n                </div>\n            </div>\n        </a>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("IndexSlide");
context.setVariable("IndexSlide", macro_t_4);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"IndexSlider\">\n        <div class=\"IndexSlider-slidesAspect\">\n            <div class=\"IndexSlider-slidesWrapper\">\n\n                <div class=\"IndexSlider-dots\">\n                </div>\n\n                <div class=\"IndexSlider-slides\">\n\n                    ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"promo");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("promo", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n                        ";
t_9 += runtime.suppressValue((lineno = 93, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "IndexSlide"), "IndexSlide", context, [t_13,runtime.makeKeywordArgs({"isPromo": true,"isActive": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first"),"index": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")})])), env.opts.autoescape);
t_9 += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") < env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts"))) {
t_9 += "\n                            ";
t_9 += runtime.suppressValue((lineno = 95, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "IndexSlide"), "IndexSlide", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")),runtime.makeKeywordArgs({"isPromo": false,"index": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")})])), env.opts.autoescape);
t_9 += "\n                        ";
;
}
t_9 += "\n                    ";
;
}
}
frame = frame.pop();
t_9 += "\n\n                    ";
t_9 += "\n                    ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"promo")) < env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts"))) {
t_9 += "\n                        ";
frame = frame.push();
var t_16 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts");
if(t_16) {t_16 = runtime.fromIterator(t_16);
var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("craft", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
t_9 += "\n                            ";
t_9 += "\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") >= env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"promo"))) {
t_9 += "\n                                ";
t_9 += runtime.suppressValue((lineno = 104, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "IndexSlide"), "IndexSlide", context, [t_17,runtime.makeKeywordArgs({"isPromo": false,"isActive": (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first") && (env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"promo")) == 0)),"index": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") + 100})])), env.opts.autoescape);
t_9 += "\n                            ";
;
}
t_9 += "\n                        ";
;
}
}
frame = frame.pop();
t_9 += "\n                    ";
;
}
t_9 += "\n                </div>\n\n                <div class=\"IndexSlider-arrows\">\n                    <div class=\"IndexSlider-slidesPrev\">\n                        ";
t_9 += runtime.suppressValue((lineno = 112, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["index-slider-arrow-prev","0 0 30 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_18 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_19 = "";;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
return macro_t_18;})()})])), env.opts.autoescape);
t_9 += "\n                    </div>\n\n                    <div class=\"IndexSlider-slidesNext\">\n                        ";
t_9 += runtime.suppressValue((lineno = 116, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["index-slider-arrow-next","0 0 30 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_21 = "";;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
return macro_t_20;})()})])), env.opts.autoescape);
t_9 += "\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("IndexSlider");
context.setVariable("IndexSlider", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexSlider/IndexSlider.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexSlider/IndexSlider.jinja
// module id = 486
// module chunks = 0